

export const frontMatter = {
	authors: [
		'noomorph',
		'jvs'
	]
};
export const contentTitle = 'Asimetrija medžu LJ/NJ i Љ/Њ';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-blog/default/site-articles-2024-07-09-diskusija-lj-nj-md-1a9.json'
export const assets = {
"authorsImageUrls": [undefined, undefined],
};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Motivacija",
  "id": "motivacija",
  "level": 2
}, {
  "value": "Fonetičny pogled",
  "id": "fonetičny-pogled",
  "level": 3
}, {
  "value": "Etimologičny pogled",
  "id": "etimologičny-pogled",
  "level": 3
}, {
  "value": "Propozicije",
  "id": "propozicije",
  "level": 2
}, {
  "value": "1. Opcionalne digrafy <code>ĹJ</code> i <code>ŃJ</code>",
  "id": "1-opcionalne-digrafy-ĺj-i-ńj",
  "level": 3
}, {
  "value": "2. Minimalno rěšenje",
  "id": "2-minimalno-rěšenje",
  "level": 3
}, {
  "value": "Nastupne kroky",
  "id": "nastupne-kroky",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    li: "li",
    ol: "ol",
    p: "p",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "motivacija",
      children: "Motivacija"
    }), "\n", _jsxs(_components.p, {
      children: ["Už několiko sedmic Jan van Steenbergen jest mnogo zajety s prěvodženjem viki-interfejsa, da byhmo mogli potom spokojno početi rabotu nad MS Vikipedijeju. To jest spěšno dělo, ibo kratko poslě publikacije našego koda ", _jsx(_components.code, {
        children: "ISO 639-3"
      }), " uže pojavilo se prědloženje za MS Vikipediju MS projekt v Inkubatoru. Ne hočemo, aby ljudi počeli kopijovati teksty iz Medžuviki, čto jest narušenje avtorskyh prav. Vměsto togo, trěba bude kopirati cělo sodržanje Medžuviki v Inkubator – zajedno s historijeju. V Medžuviki jest avtomatičny transliterator, da by čitatelji mogli izbirati medžu latiniceju i kiriliceju. Očevidno, v Vikipediji on takože bude potrěbny. Tu jest jedin maly problem."]
    }), "\n", _jsxs(_components.p, {
      children: ["Tutdenj medžuslovjansky pravopis imaje asimetriju medžu latiniceju i kiriliceju, čto se tyče prědavanja digrafov ", _jsx(_components.code, {
        children: "lj"
      }), " i ", _jsx(_components.code, {
        children: "nj"
      }), " na pismu, i to jest objekt našej diskusije niže."]
    }), "\n", _jsx(_components.h3, {
      id: "fonetičny-pogled",
      children: "Fonetičny pogled"
    }), "\n", _jsx(_components.p, {
      children: "Sut 3 možne situacije iz pozicije fonetiky (priměry sut zapisane v tutdennom etimologičnom pravopisu):"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "lj"
        }), " i ", _jsx(_components.code, {
          children: "nj"
        }), " označajut mekke ", _jsx(_components.code, {
          children: "L"
        }), " i ", _jsx(_components.code, {
          children: "N"
        }), ": ", _jsx(_components.code, {
          children: "detalj"
        }), " (", _jsx(_components.code, {
          children: "детаљ"
        }), "), ", _jsx(_components.code, {
          children: "konj"
        }), " (", _jsx(_components.code, {
          children: "коњ"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "lj"
        }), " i ", _jsx(_components.code, {
          children: "nj"
        }), " označajut tvrde ", _jsx(_components.code, {
          children: "L"
        }), " i ", _jsx(_components.code, {
          children: "N"
        }), ", i poslě togo ide samostojno ", _jsx(_components.code, {
          children: "J"
        }), ": ", _jsx(_components.code, {
          children: "injekcija"
        }), "\n(", _jsx(_components.code, {
          children: "инјекција"
        }), "), ", _jsx(_components.code, {
          children: "konjunkcija"
        }), " (", _jsx(_components.code, {
          children: "конјункција"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "lj"
        }), " i ", _jsx(_components.code, {
          children: "nj"
        }), " označajut mekke ", _jsx(_components.code, {
          children: "L"
        }), " i ", _jsx(_components.code, {
          children: "N"
        }), ", i poslě togo ide samostojno ", _jsx(_components.code, {
          children: "J"
        }), ": ", _jsx(_components.code, {
          children: "usiĺje"
        }), " (", _jsx(_components.code, {
          children: "усильје"
        }), "),\n", _jsx(_components.code, {
          children: "pisańje"
        }), " (", _jsx(_components.code, {
          children: "писаньје"
        }), ")"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Podolg standarda, v medžuslovjanskoj latinici vse tri situacije trěbujut pisati ", _jsx(_components.code, {
        children: "lj"
      }), " i ", _jsx(_components.code, {
        children: "nj"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Jednakože, v standardnoj kirilici, prva situacija zapisyvaje se s ", _jsx(_components.code, {
        children: "љ"
      }), " i ", _jsx(_components.code, {
        children: "њ"
      }), ", ale v situacijah №2 i №3 pišemo: ", _jsx(_components.code, {
        children: "лј"
      }), " i ", _jsx(_components.code, {
        children: "нј"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Tuta asimetrija tvori problem, že pri transliterovanju ", _jsx(_components.code, {
        children: "љ"
      }), "/", _jsx(_components.code, {
        children: "лј"
      }), " i ", _jsx(_components.code, {
        children: "њ"
      }), "/", _jsx(_components.code, {
        children: "нј"
      }), " iz kirilice do latinice dostavajemo: ", _jsx(_components.code, {
        children: "lj"
      }), "/", _jsx(_components.code, {
        children: "lj"
      }), " i ", _jsx(_components.code, {
        children: "nj"
      }), "/", _jsx(_components.code, {
        children: "nj"
      }), ". Zatože informacija gubi se, povtorno transliterovanje do kirilice, samorazumno, už davaje ", _jsx(_components.code, {
        children: "љ"
      }), "/", _jsx(_components.code, {
        children: "љ"
      }), " i ", _jsx(_components.code, {
        children: "њ"
      }), "/", _jsx(_components.code, {
        children: "њ"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Paradoks je taky: teoretično kirilica dozvaljaje zapisati vse tri situacije bez razširjenja abecedy, koristajuči  simboly už dostupne nam: ", _jsx(_components.code, {
        children: "Ј"
      }), ", ", _jsx(_components.code, {
        children: "Л"
      }), ", ", _jsx(_components.code, {
        children: "Љ"
      }), ", ", _jsx(_components.code, {
        children: "Н"
      }), ", ", _jsx(_components.code, {
        children: "Њ"
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "детаљ"
        }), ", ", _jsx(_components.code, {
          children: "коњ"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "инјекција"
        }), ", ", _jsx(_components.code, {
          children: "конјункција"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "усиљје"
        }), ", ", _jsx(_components.code, {
          children: "писањје"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Ale v latinici my ne možemo najdti prostogo razrěšenja asimetrije bez dodatnogo označenja mekkosti ili tvrdosti bukv ", _jsx(_components.code, {
        children: "L"
      }), " i ", _jsx(_components.code, {
        children: "N"
      }), " v digrafah ", _jsx(_components.code, {
        children: "LJ"
      }), " i ", _jsx(_components.code, {
        children: "NJ"
      }), ", napr.:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "detalj"
        }), ", ", _jsx(_components.code, {
          children: "konj"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "in'jekcija"
        }), ", ", _jsx(_components.code, {
          children: "kon'junkcija"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "usiĺje"
        }), ", ", _jsx(_components.code, {
          children: "pisańje"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Jaroslav Sergějev"
      })
    }), "\n", _jsx(_components.h3, {
      id: "etimologičny-pogled",
      children: "Etimologičny pogled"
    }), "\n", _jsx(_components.p, {
      children: "Imajemo dělo s 4 kategorijami:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["osnovne (tvrde) suglasky, plus ", _jsx(_components.strong, {
          children: "c"
        }), " i ", _jsx(_components.strong, {
          children: "j"
        }), ": ", _jsx(_components.code, {
          children: "#"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["smekčenje: ", _jsx(_components.code, {
          children: "#ь"
        }), " (napr. ", _jsx(_components.code, {
          children: "konj"
        }), ", ", _jsx(_components.code, {
          children: "bolj"
        }), ", ", _jsx(_components.code, {
          children: "kosť"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["jotacija tvrdoj suglasky: ", _jsx(_components.code, {
          children: "#j"
        }), " (napr.: ", _jsx(_components.code, {
          children: "hot-jų"
        }), " → ", _jsx(_components.code, {
          children: "hoćų"
        }), ", ", _jsx(_components.code, {
          children: "hval-jeńje"
        }), " → ", _jsx(_components.code, {
          children: "hvaljeńje"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["jotacija smekčenoj suglasky: ", _jsx(_components.code, {
          children: "#ьj"
        }), " (napr. ", _jsx(_components.code, {
          children: "pisańje"
        }), ", ", _jsx(_components.code, {
          children: "usiĺje"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Kako to funkcionuje, pokažemo v tabelě niže:"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Etimologičny pravopis:"
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "#"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "l"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "n"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "r"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "t"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "d"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "s"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "z"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "p"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "k"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "c"
            })
          }), _jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "j"
            })
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "#ь"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "ĺ"
            }), ", ", _jsx(_components.code, {
              children: "lj"
            })]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "ń"
            }), ", ", _jsx(_components.code, {
              children: "nj"
            })]
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ŕ"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "t́"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "d́"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ś"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ź"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "p"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "č"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "č"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "j"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "#j"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "lj"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "nj"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "rj"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ć"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "đ"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "š"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ž"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "pj"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "č"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "č"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "j"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "#ьj"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ĺ"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ń"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ŕ"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "t́j"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "d́j"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ś"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "ź"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "pj"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "č"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "č"
            })
          }), _jsxs(_components.td, {
            children: ["*", _jsx(_components.code, {
              children: "jj"
            })]
          })]
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Standardny pravopis (lat./kir.):"
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: _jsx(_components.code, {
              children: "#"
            })
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "l"
            }), " ", _jsx(_components.code, {
              children: "л"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "n"
            }), " ", _jsx(_components.code, {
              children: "н"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "r"
            }), " ", _jsx(_components.code, {
              children: "р"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "t"
            }), " ", _jsx(_components.code, {
              children: "т"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "d"
            }), " ", _jsx(_components.code, {
              children: "д"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "s"
            }), " ", _jsx(_components.code, {
              children: "с"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "z"
            }), " ", _jsx(_components.code, {
              children: "з"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "p"
            }), " ", _jsx(_components.code, {
              children: "п"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "k"
            }), " ", _jsx(_components.code, {
              children: "к"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "c"
            }), " ", _jsx(_components.code, {
              children: "ц"
            })]
          }), _jsxs(_components.th, {
            children: [_jsx(_components.code, {
              children: "j"
            }), " ", _jsx(_components.code, {
              children: "ј"
            })]
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "#ь"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "lj"
            }), " (", _jsx(_components.code, {
              children: "љ"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "nj"
            }), " (", _jsx(_components.code, {
              children: "њ"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "r"
            }), " (", _jsx(_components.code, {
              children: "р"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "t"
            }), " (", _jsx(_components.code, {
              children: "т"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "d"
            }), " (", _jsx(_components.code, {
              children: "д"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "s"
            }), " (", _jsx(_components.code, {
              children: "с"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "z"
            }), " (", _jsx(_components.code, {
              children: "з"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "p"
            }), " (", _jsx(_components.code, {
              children: "п"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "č"
            }), " (", _jsx(_components.code, {
              children: "ч"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "č"
            }), " (", _jsx(_components.code, {
              children: "ч"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "j"
            }), " (", _jsx(_components.code, {
              children: "ј"
            }), ")"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "#j"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "lj"
            }), " (", _jsx(_components.code, {
              children: "љ"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "nj"
            }), " (", _jsx(_components.code, {
              children: "њ"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "rj"
            }), " (", _jsx(_components.code, {
              children: "рј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "č"
            }), " (", _jsx(_components.code, {
              children: "ч"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dž"
            }), " (", _jsx(_components.code, {
              children: "дж"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "š"
            }), " (", _jsx(_components.code, {
              children: "ш"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "ž"
            }), " (", _jsx(_components.code, {
              children: "ж"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "pj"
            }), " (", _jsx(_components.code, {
              children: "пј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "č"
            }), " (", _jsx(_components.code, {
              children: "ч"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "č"
            }), " (", _jsx(_components.code, {
              children: "ч"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "j"
            }), " (", _jsx(_components.code, {
              children: "ј"
            }), ")"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "#ьj"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "lj"
            }), " (", _jsx(_components.code, {
              children: "лј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "ń"
            }), " (", _jsx(_components.code, {
              children: "нј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "rj"
            }), " (", _jsx(_components.code, {
              children: "рј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "tj"
            }), " (", _jsx(_components.code, {
              children: "тј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dj"
            }), " (", _jsx(_components.code, {
              children: "дј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "sj"
            }), " (", _jsx(_components.code, {
              children: "сј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "zj"
            }), " (", _jsx(_components.code, {
              children: "зј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "pj"
            }), " (", _jsx(_components.code, {
              children: "пј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "č"
            }), " (", _jsx(_components.code, {
              children: "чј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "č"
            }), " (", _jsx(_components.code, {
              children: "чј"
            }), ")"]
          }), _jsxs(_components.td, {
            children: ["*", _jsx(_components.code, {
              children: "jj"
            }), " (*", _jsx(_components.code, {
              children: "јј"
            }), ")"]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Začto ", _jsx(_components.code, {
          children: "lь"
        }), "/", _jsx(_components.code, {
          children: "nь"
        }), " mogut stati i ", _jsx(_components.code, {
          children: "ĺ"
        }), "/", _jsx(_components.code, {
          children: "ń"
        }), ", i ", _jsx(_components.code, {
          children: "lj"
        }), "/", _jsx(_components.code, {
          children: "nj"
        }), "? Ta razlika ne jest etimologična, ale morfologična.\nPišemo ", _jsx(_components.code, {
          children: "siĺny"
        }), " i ", _jsx(_components.code, {
          children: "slovjańsky"
        }), ", ale takože ", _jsx(_components.code, {
          children: "cěljny"
        }), " i ", _jsx(_components.code, {
          children: "prijateljsky"
        }), ", zatože prosto dodavajemo do korenja sufiksy ", _jsx(_components.code, {
          children: "-ny"
        }), ", ", _jsx(_components.code, {
          children: "-sky"
        }), ", i druge. Palatalizujemo jedino ", _jsx(_components.code, {
          children: "k"
        }), "/", _jsx(_components.code, {
          children: "g"
        }), "/", _jsx(_components.code, {
          children: "h"
        }), " – zato ", _jsx(_components.code, {
          children: "sil-ny"
        }), " → ", _jsx(_components.code, {
          children: "siĺny"
        }), ", ale ", _jsx(_components.code, {
          children: "rųk-ny"
        }), " → ", _jsx(_components.code, {
          children: "rųčny"
        }), ". To jest malo narušenje etimologije.", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["Interesno, že tu imajemo až 3 versije: ", _jsx(_components.code, {
              children: "pȯlny"
            }), " (v značenju: ", _jsx(_components.em, {
              children: "ne prazdny"
            }), "), ", _jsx(_components.code, {
              children: "poĺny"
            }), "\n(od imennika ", _jsx(_components.em, {
              children: "pol"
            }), "), ", _jsx(_components.code, {
              children: "poljny"
            }), " (od imennika ", _jsx(_components.em, {
              children: "polje"
            }), ")."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Jest razlika medžu palatalizacijeju (", _jsx(_components.code, {
          children: "ь"
        }), ") i jotaciju (", _jsx(_components.code, {
          children: "j"
        }), "), ale poslě ", _jsx(_components.code, {
          children: "l"
        }), " i ", _jsx(_components.code, {
          children: "n"
        }), " one sběgajut se v ", _jsx(_components.code, {
          children: "lj"
        }), " i ", _jsx(_components.code, {
          children: "nj"
        }), ". Tako jest vo vsih slovjanskyh jezykah. Jednakože, ako htěli byhmo igrati najvyše «čisto», trěba by bylo pisati ", _jsx(_components.code, {
          children: "хвалју"
        }), " i ", _jsx(_components.code, {
          children: "хранјены"
        }), " zaměsto ", _jsx(_components.code, {
          children: "хваљу"
        }), " i ", _jsx(_components.code, {
          children: "храњены"
        }), ". Nu, ale to ne jest veliky problem."]
      }), "\n", _jsxs(_components.li, {
        children: ["Naš problem jest ta poslědnja kategorija (", _jsx(_components.code, {
          children: "ьј"
        }), "). Tvoret ju sufiksy ", _jsx(_components.code, {
          children: "-je"
        }), ", ", _jsx(_components.code, {
          children: "-ji"
        }), " i končina ", _jsx(_components.code, {
          children: "-jų"
        }), ". Mnogo važno jest to, že te sufiksy možno jest razpoznati. I kromě togo, tamte sufiksy vnoset razliku v gramatiku (roditeljnik množiny ", _jsx(_components.code, {
          children: "-ij"
        }), ", napr.: ", _jsx(_components.code, {
          children: "znańje"
        }), " → ", _jsx(_components.code, {
          children: "znanij"
        }), " zaměsto ", _jsx(_components.code, {
          children: "znanj"
        }), "). Razlika so smekčenjem i jotacijeju takože jest važna, zatože slovjanske jezyky različno podhodet do tutogo pytanja: russky ", _jsx(_components.code, {
          children: "-ие"
        }), "/", _jsx(_components.code, {
          children: "-ье"
        }), ", ukrajinsky ", _jsx(_components.code, {
          children: "-ння"
        }), ", bělorussky\n", _jsx(_components.code, {
          children: "-нне"
        }), ", poljsky i slovačsky ", _jsx(_components.code, {
          children: "-nie"
        }), ", češsky ", _jsx(_components.code, {
          children: "-ní"
        }), ", slovensky ", _jsx(_components.code, {
          children: "-nje"
        }), ", srbohrvatsky i makedonsky ", _jsx(_components.code, {
          children: "-nje"
        }), " (", _jsx(_components.code, {
          children: "-ње"
        }), "), bulgarsky ", _jsx(_components.code, {
          children: "-не"
        }), "."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["My jesmo izbrali slovenečsky (🇸🇮) model, ale ne zabezpametimo, že jest razlika medžu slovenskym i srbohrvatskym modelami. V ", _jsx(_components.code, {
        children: "BCMS"
      }), " jezykah proces byl taky: ", _jsx(_components.code, {
        children: "-#ьје"
      }), " → ", _jsx(_components.code, {
        children: "-#^e"
      }), " (polna jotacija), napr.: ", _jsx(_components.code, {
        children: "*pitьje"
      }), " → ", _jsx(_components.code, {
        children: "piće"
      }), ", ", _jsx(_components.code, {
        children: "zdravьje"
      }), " → ", _jsx(_components.code, {
        children: "zdravlje*"
      }), ". V slovenskom, iz drugoj strany, toj ", _jsx(_components.code, {
        children: "ь"
      }), " kakoby \"blokuje\" jotaciju, zato slovensky imaje ", _jsx(_components.code, {
        children: "pitje"
      }), ", ", _jsx(_components.code, {
        children: "zdravje"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Etimologično najvyše čisto byl by taky zapis:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "pisańje"
        }), " (", _jsx(_components.code, {
          children: "писањје"
        }), "), ili ", _jsx(_components.code, {
          children: "pisaňje"
        }), " (", _jsx(_components.code, {
          children: "писаньје"
        }), ");"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "usiĺje"
        }), " (", _jsx(_components.code, {
          children: "усиљје"
        }), "), ili ", _jsx(_components.code, {
          children: "usiľje"
        }), " (", _jsx(_components.code, {
          children: "усильје"
        }), ");"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "piťje"
        }), " (", _jsx(_components.code, {
          children: "питьје"
        }), "), ale standardny pravopis ne imaje ", _jsx(_components.code, {
          children: "ť"
        }), ", zato pišemo ", _jsx(_components.code, {
          children: "pitje"
        }), " (", _jsx(_components.code, {
          children: "питје"
        }), ")."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Tako razrěšenje by služilo kako dobry kompromis medžu ", _jsx(_components.code, {
        children: "-#ije"
      }), " (🇷🇺🇧🇬☦), ", _jsx(_components.code, {
        children: "-#'e"
      }), " (🇵🇱), ", _jsx(_components.code, {
        children: "-#je"
      }), " (🇸🇮) i ", _jsx(_components.code, {
        children: "-#^e"
      }), " (🇷🇸🇭🇷)."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Jan van Steenbergen"
      })
    }), "\n", _jsx(_components.h2, {
      id: "propozicije",
      children: "Propozicije"
    }), "\n", _jsxs(_components.h3, {
      id: "1-opcionalne-digrafy-ĺj-i-ńj",
      children: ["1. Opcionalne digrafy ", _jsx(_components.code, {
        children: "ĹJ"
      }), " i ", _jsx(_components.code, {
        children: "ŃJ"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Dodati ", _jsx(_components.code, {
        children: "ń"
      }), " (", _jsx(_components.code, {
        children: "ň"
      }), ") i ", _jsx(_components.code, {
        children: "ĺ"
      }), " (", _jsx(_components.code, {
        children: "ľ"
      }), ") kako opcionalne dodatky do standardnogo pravopisanja v situaciji nejasnosti, kogdy ", _jsx(_components.code, {
        children: "lj"
      }), "/", _jsx(_components.code, {
        children: "nj"
      }), " označajut jotovane mekke ", _jsx(_components.code, {
        children: "L"
      }), "/", _jsx(_components.code, {
        children: "N"
      }), ", napr.: ", _jsx(_components.code, {
        children: "pisańje"
      }), ", ", _jsx(_components.code, {
        children: "usiĺje"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "V Medžuviki to uže bylo sdělano čestično i funkcionuje dobro.\nDodatočna prědnost togo razrěšenja jest to, že uže ne bude problemov s deklinacijeju."
    }), "\n", _jsxs(_components.p, {
      children: ["Akcentuju, že ono jest potrěbno samo za transliteraciju: v normalnoj komunikaciji možno\njest, očevidno, pisati ", _jsx(_components.code, {
        children: "pisanje"
      }), " i ", _jsx(_components.code, {
        children: "usilje"
      }), " kako prědže."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Jan van Steenbergen"
      })
    }), "\n", _jsx(_components.h3, {
      id: "2-minimalno-rěšenje",
      children: "2. Minimalno rěšenje"
    }), "\n", _jsx(_components.p, {
      children: "Iz analizy vyše viděli jesmo, že dobra simetrija medžu latiniceju i kiriliceju trěbovala by byti:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["ili 3:3, čto znači \"imati latinične analogy\" za: ", _jsx(_components.code, {
          children: "љ"
        }), "/", _jsx(_components.code, {
          children: "њ"
        }), ", ", _jsx(_components.code, {
          children: "љј"
        }), "/", _jsx(_components.code, {
          children: "њј"
        }), ", ", _jsx(_components.code, {
          children: "лј"
        }), "/", _jsx(_components.code, {
          children: "нј"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["abo 1:1 (", _jsx(_components.code, {
          children: "lj"
        }), "-", _jsx(_components.code, {
          children: "љ"
        }), ", ", _jsx(_components.code, {
          children: "nj"
        }), "-", _jsx(_components.code, {
          children: "њ"
        }), ")."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Kompromisno rěšenje koristati ", _jsx(_components.code, {
        children: "Ĺ"
      }), " i ", _jsx(_components.code, {
        children: "Ń"
      }), " samo v digrafah ", _jsx(_components.code, {
        children: "ĹJ"
      }), "/", _jsx(_components.code, {
        children: "ŃJ"
      }), " dělaje standardny pravopis vyše komplikovanym, i zajedno s tym:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["pri učenju, trěbuje pametati dodatno o morfologiji i sufiksah: ", _jsx(_components.code, {
          children: "učeń-je"
        }), ", ", _jsx(_components.code, {
          children: "usiĺ-je"
        }), ", i zato je izbor:", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["abo učeniki budut pametati kako sklanjajut se slova, napr: ", _jsx(_components.code, {
              children: "polje"
            }), " → ", _jsx(_components.code, {
              children: "polj"
            }), ", ", _jsx(_components.code, {
              children: "učenje"
            }), " → ", _jsx(_components.code, {
              children: "učenij"
            }), ";"]
          }), "\n", _jsxs(_components.li, {
            children: ["ili učeniki budut pametati kde trěba pisati črtky nad ", _jsx(_components.code, {
              children: "LJ"
            }), " i ", _jsx(_components.code, {
              children: "NJ"
            }), ", a kde ne, i od togo izvoditi formy roditeljnika;"]
          }), "\n", _jsx(_components.li, {
            children: "i prvo, i drugo trěbuje bliz podobno usilje dlja pameti, a zato imajemo pytanje \"začto razširjati pravopis\", kogdy jego možno ne razširjati?"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["ne jest polno podobno do južnyh jezykov, kde piše se, napr.: ", _jsx(_components.code, {
          children: "учење"
        }), " 🇷🇸, ", _jsx(_components.code, {
          children: "знаење"
        }), " 🇲🇰, ", _jsx(_components.code, {
          children: "питане"
        }), " 🇧🇬."]
      }), "\n", _jsxs(_components.li, {
        children: ["ne jest polno podobno do sěvěrnyh jezykov, kde piše se, napr.: ", _jsx(_components.code, {
          children: "spanie"
        }), " 🇵🇱 (a ne: ", _jsx(_components.code, {
          children: "spańje"
        }), "), ", _jsx(_components.code, {
          children: "ученье"
        }), " 🇷🇺 (a ne: ", _jsx(_components.code, {
          children: "ученје"
        }), ")."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Imenno zato najprosty variant by byl koristati samo ligatury ", _jsx(_components.code, {
        children: "љ"
      }), "/", _jsx(_components.code, {
        children: "њ"
      }), " v kirilici:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "izguba etimologičnoj informacije byla by ravna medžu alfabetami;"
      }), "\n", _jsx(_components.li, {
        children: "pytanje najvyše fonetično razumlivogo izgovora slova nikogdy ne može byti polno adresovano bez pogledanja na etimologičny zapis slova;"
      }), "\n", _jsxs(_components.li, {
        children: ["vizualno, zapis ", _jsx(_components.code, {
          children: "знање"
        }), " i ", _jsx(_components.code, {
          children: "питање"
        }), " ne zlo by koreloval s ", _jsx(_components.code, {
          children: "знанье"
        }), " 🇷🇺, ", _jsx(_components.code, {
          children: "питання"
        }), " 🇺🇦, ", _jsx(_components.code, {
          children: "питане"
        }), " 🇧🇬."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Trěba takože pripomněti čitateljam ", _jsx(_components.strong, {
        children: "nemožnost polnogo programatičnogo rěšenja"
      }), " problema s ", _jsx(_components.code, {
        children: "љ"
      }), "/", _jsx(_components.code, {
        children: "лј"
      }), " i ", _jsx(_components.code, {
        children: "њ"
      }), "/", _jsx(_components.code, {
        children: "нј"
      }), ", ktoro raněje proponovalo se kako alternativa vsakoj reformě jezyka. Na žalost, ne vsaky raz možno izjaviti s 100% uvěrjenostju čto znači někaka rěč – sut homonimy v medžuslovjanskom leksikonu, i v takoj situaciji, jedino algoritmy s umětnoju inteligencijeju (", _jsx(_components.code, {
        children: "AI"
      }), ") budut smogti točno skazati čto to jest, napr: ", _jsx(_components.code, {
        children: "usiljam"
      }), " kako v ", _jsx(_components.code, {
        children: "ja usiljam"
      }), " (glagol s tvrdym ", _jsx(_components.code, {
        children: "L"
      }), ") abo ", _jsx(_components.code, {
        children: "hvala usiĺjam"
      }), " (imennik s mekkym L)."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Jaroslav Sergějev"
      })
    }), "\n", _jsx(_components.h2, {
      id: "nastupne-kroky",
      children: "Nastupne kroky"
    }), "\n", _jsx(_components.p, {
      children: "Prvo, čitatelj može ješče pročitati tutoj dokument, kde obgovarjali se mnoge ine propozicije i pytanja okolo poslědic raznyh reform:"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://docs.google.com/document/d/1XihmB0ETegx2PxKG0EIGUY6Sm0Kz9t21KViRlt-zCus",
        children: "Medžuslovjansko Věče (22.06.2024)"
      })
    }), "\n", _jsx(_components.p, {
      children: "Dalje, trěbujemo obgovoriti s pomočnikami razvoja medžuslovjanskogo jezyka argumenty i kontrargumenty vsakoj propozicije v komentarah niže ."
    }), "\n", _jsx(_components.p, {
      children: "I, v koncu, Medžuslovjanska Jezyčna Komisija glasuje za jedin iz variantov."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

